import { render } from "./StudentClassesSelectPopupItem.vue?vue&type=template&id=227262d2&scoped=true&ts=true"
import script from "./StudentClassesSelectPopupItem.vue?vue&type=script&lang=ts"
export * from "./StudentClassesSelectPopupItem.vue?vue&type=script&lang=ts"

import "./StudentClassesSelectPopupItem.vue?vue&type=style&index=0&id=227262d2&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227262d2"]])

export default __exports__